import React, { Component } from 'react';
import axios, { AxiosRequestConfig } from 'axios';

const iris = {
  0: 'Iris-setosa',
  1: 'Iris-versicolor',
  2: 'Iris-virginica',
};
export default class ML extends Component<{}, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      sl: '1.2',
      sw: '1.3',
      pl: '2.1',
      pw: '1.4',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleSubmit(event: any) {
    event.preventDefault();
    const { sl, sw, pl, pw } = this.state;
    const data = JSON.stringify({ sl: sl, sw: sw, pl: pl, pw: pw });

    const config: AxiosRequestConfig = {
      method: 'post',
      url: 'https://evening-caverns-08307.herokuapp.com/predict',
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        const dataRes = JSON.stringify(response.data);
        const idx = dataRes.lastIndexOf('[');
        const flower = dataRes[idx + 1] as string;
        const first = dataRes.slice(0, idx);
        console.log(iris[flower]);

        alert(first + iris[flower]);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  handleChange(event: any) {
    this.setState({ [event.target.name]: event.target.value });
    console.log(this.state.sl);
  }

  render() {
    const { sl, sw, pl, pw } = this.state;
    return (
      <React.Fragment>
        <section id="ML" className="s-resume target-section">
          <div className="row s-resume__section">
            <div className="column large-3 tab-12">
              <h3 className="section-header-allcaps">ML Project</h3>
            </div>
            <div className="column large-9 tab-12">
              <p>
                Welcome, here I am using a back end Python Flask app which
                allows me to POST a JSON body that contains the values for the
                classic Machine Learning project for{' '}
                <a href="https://www.kaggle.com/uciml/iris">
                  iris data classification
                </a>
                . You can enter different values for the sepal length, width and
                petal length, width to this KNN classification model hosted in a
                dockerized heroku backend flask app. The model can classify the
                species based on the input values and its pre learned dataset.
              </p>
              <p>
                Please wait a few seconds for the backend to response ~ about 10
                seconds.
              </p>
            </div>
            <div className="column large-3 tab-12"></div>
            <form
              className="column large-9 tab-12"
              onSubmit={this.handleSubmit}
            >
              <span style={{ display: 'inline-flex' }}>
                <div style={{ marginRight: 45 }}>
                  <input
                    type="text"
                    placeholder={`SepalLength : ${sl}`}
                    name="sl"
                    onChange={this.handleChange}
                  />
                </div>
                <div style={{ marginRight: 45 }}>
                  <input
                    type="text"
                    placeholder={`SepalWidth : ${sw}`}
                    name="sw"
                    onChange={this.handleChange}
                  />
                </div>
              </span>
              <span style={{ display: 'inline-flex' }}>
                <div style={{ marginRight: 45 }}>
                  <input
                    type="text"
                    placeholder={`PetalLength : ${pl}`}
                    name="pl"
                    onChange={this.handleChange}
                  />
                </div>
                <div style={{ marginRight: 45 }}>
                  <input
                    type="text"
                    placeholder={`SepalWidth : ${pw}`}
                    name="pw"
                    onChange={this.handleChange}
                  />
                </div>
                <div style={{ marginRight: 45 }}>
                  <button> Submit </button>
                </div>
              </span>
            </form>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
